import downloadFile from '../Services/downloadFile';
import downloadMultiple from '../Services/downloadMultiple';
import selectListItems from '../Selectors/selectListItems';

export default () => async (dispatch, getState) => {

  const state = getState();
  const { checkedItemPaths } = state.screens.ProjectView;
  const listItems = selectListItems(state);

  // Get full item objects for checked paths
  const checkedItems = listItems.filter(item => 
    checkedItemPaths.includes(item.path)
  );

  // If multiple items or any directory, use ZIP download
  if (checkedItems.length > 1 || checkedItems.some(item => item.type === 'directory')) {
    await dispatch(downloadMultiple(checkedItemPaths));
  } else if (checkedItems.length === 1) {
    // Single file - use direct S3 download
    await dispatch(downloadFile(checkedItemPaths[0]));
  }

}